var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWho(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.007,
    height: 49,
    viewBox: "0 0 48.007 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "payment",
    transform: "translate(-0.111 0.684)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "payment-2",
    "data-name": "payment",
    transform: "translate(0 -0.237)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1211",
    "data-name": "Ellipse 1211",
    cx: 24,
    cy: 24.5,
    rx: 24,
    ry: 24.5,
    transform: "translate(0.111 -0.446)",
    fill: "#53b3cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15056",
    "data-name": "Path 15056",
    d: "M168.166,85.186c0-.967-6.336-7.008-9.34-9.648l-9.975.543-4.741-3.839-4.263.531L126.366,83.594l11.471,25.368a24.167,24.167,0,0,0,30.329-23.776Z",
    transform: "translate(-120.049 -61.29)",
    fill: "#3f9eb5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rain",
    transform: "translate(6.043 7.951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15048",
    "data-name": "Path 15048",
    d: "M28.588,21.184a7.813,7.813,0,0,0-1.328.121,10.388,10.388,0,0,0-18.134,0A7.793,7.793,0,1,0,7.8,36.777H28.588a7.8,7.8,0,1,0,0-15.593Z",
    transform: "translate(0 -15.986)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15049",
    "data-name": "Path 15049",
    d: "M234.419,79.986a7.814,7.814,0,0,0-1.328.121c-.008-.014-.019-.027-.027-.041a10.384,10.384,0,0,1-9.038,15.513h10.393a7.8,7.8,0,0,0,0-15.593Z",
    transform: "translate(-205.832 -74.788)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6793",
    "data-name": "Group 6793",
    transform: "translate(5.709 22.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15050",
    "data-name": "Path 15050",
    d: "M177.043,312.325a1.043,1.043,0,0,1-.988-1.372l2.084-6.253a1.042,1.042,0,1,1,1.976.659l-2.084,6.253A1.042,1.042,0,0,1,177.043,312.325Z",
    transform: "translate(-171.832 -302.64)",
    fill: "#a4c4e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15051",
    "data-name": "Path 15051",
    d: "M177.043,312.325a1.043,1.043,0,0,1-.988-1.372l2.084-6.253a1.042,1.042,0,1,1,1.976.659l-2.084,6.253A1.042,1.042,0,0,1,177.043,312.325Z",
    transform: "translate(-171.832 -302.64)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15052",
    "data-name": "Path 15052",
    d: "M177.043,312.325a1.043,1.043,0,0,1-.988-1.372l2.084-6.253a1.042,1.042,0,1,1,1.976.659l-2.084,6.253A1.042,1.042,0,0,1,177.043,312.325Z",
    transform: "translate(-161.41 -302.64)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15053",
    "data-name": "Path 15053",
    d: "M273.043,309.2a1.043,1.043,0,0,1-.988-1.372L273.1,304.7a1.042,1.042,0,1,1,1.976.659l-1.042,3.126A1.042,1.042,0,0,1,273.043,309.2Z",
    transform: "translate(-261.579 -301.076)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15054",
    "data-name": "Path 15054",
    d: "M273.043,309.2a1.043,1.043,0,0,1-.988-1.372L273.1,304.7a1.042,1.042,0,1,1,1.976.659l-1.042,3.126A1.042,1.042,0,0,1,273.043,309.2Z",
    transform: "translate(-250.853 -303.683)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15055",
    "data-name": "Path 15055",
    d: "M113.043,309.2a1.043,1.043,0,0,1-.988-1.372L113.1,304.7a1.042,1.042,0,1,1,1.976.659l-1.042,3.126A1.042,1.042,0,0,1,113.043,309.2Z",
    transform: "translate(-112.001 -303.986)",
    fill: "#f3f3f3"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWho);
export default __webpack_public_path__ + "static/media/icon-who.f1e232bc.svg";
export { ForwardRef as ReactComponent };